import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginPage } from "./pages/login/login-page.component";
import { NotFoundPage } from "./pages/not-found/not-found-page.component";

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/tabs/tabs.module').then(m => m.TabsPageModule) },
  { path: 'login', data: { meta: { title: 'Регистрация' } }, component: LoginPage, },
  { path: '**', data: { meta: { title: '404 - Hot shots' } }, pathMatch: 'full', component: NotFoundPage },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
